export default class VideoOrganizationController {
  constructor($rootScope, $scope, $uibModal, $http) {
    this.account = $rootScope.account;
    this.rootScope = $rootScope;
    this.$http = $http;
    this.signedUp = false;
    this.finished = false;
    this.$uibModal = $uibModal;
    this.scope = $scope;
    this.scope.channelSelected = '';
    this.scope.channelOptions = [];
    this.showList = false;
    this.tableData = [];
    this.updateChannelOptions();

    if (localStorage.getItem('checkStepComplete') != null) {
      this.finished = true;
      this.rootScope.$emit('checkValidation', true);
    }

    $scope.$watch('channelSelected', (channelSelected) => {
      if (channelSelected != '') {
        //Call API
        this.$http
          .get(
            `${API_ROOT}/account/migration/channels/${channelSelected.boxcast_channel_id}/preview_convert_to_portal`
          )
          .then((resp) => {
            this.tableData = [
              {
                name: channelSelected.name,
                smIcon: this.getIcon('Channel'),
                bcIcon: this.getIcon('Video Portal'),
                indent: '0px',
              },
            ];
            if (resp.data.portal_channels) {
              this.createTable(resp.data.portal_channels, 1);
            }
          });
      }
    });
  }

  openSkip = () => {
    this.$uibModal
      .open({
        template: require('./modals/skip-setup.html'),
        controller: require('./modals/skip-setup').default,
        controllerAs: 'vm',
        resolve: {
          activeTab: () => null,
        },
      })
      .result.then((skipRes) => {
        this.finished = skipRes;
        if (skipRes) {
          localStorage.setItem('checkStepComplete', 'true');
          this.rootScope.$emit('checkValidation', true);
        }
      });
  };

  openSetup = () => {
    this.$uibModal
      .open({
        scope: this.scope,
        template: require('./modals/setup-portal.html'),
        controller: require('./modals/setup-portal').default,
        controllerAs: 'vm',
        resolve: {
          activeTab: () => null,
        },
      })
      .result.then((check) => {
        this.finished = check.finished;
        this.signedUp = check.signedUp;
        if (check.finished && check.signedUp) {
          this.$http
            .post(
              `${API_ROOT}/account/migration/channels/${this.scope.channelSelected.boxcast_channel_id}/convert_to_portal`
            )
            .then((resp) => {});
          this.rootScope.$emit('checkValidation', true);
        }
      });
  };

  createTable(children, count) {
    for (const child of children) {
      const { name, tags } = child;

      this.tableData.push({
        name: name,
        smIcon: this.getIcon('Folder'),
        bcIcon: this.getIcon('Channel'),
        indent: `${count * 25}px`,
      });

      if (tags) {
        for (const tag of tags) {
          this.tableData.push({
            name: tag,
            smIcon: this.getIcon('Folder'),
            bcIcon: this.getIcon('Tag'),
            indent: `${(count + 1) * 25}px`,
          });
        }
      }
    }
  }

  getIcon(iconType) {
    if (iconType == 'Video Portal') {
      return 'fa fa-light fa-play-circle';
    } else if (iconType == 'Channel') {
      return 'fa fa-light fa-tv';
    } else if (iconType == 'Folder') {
      return 'fa fa-light fa-folder';
    } else if (iconType == 'Tag') {
      return 'fa fa-light fa-tag';
    }
  }

  updateChannelOptions() {
    this.$http.get(`${API_ROOT}/account/migration/channels`).then((resp) => {
      for (const obj of resp.data) {
        if (obj.monkey_channel_id) {
          this.scope.channelOptions.push(obj);
        }
        if (obj.converted_to_portal) {
          this.finished = true;
          this.signedUp = true;
          this.scope.channelSelected = obj;
          this.rootScope.$emit('checkValidation', true);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/video-organization.js